import { ItemCategoryTypes, PartTypes, LabourTimeTypes, QuoteItemStatusTypes, EventHubTypes } from '@/enums'
import QuoteTotalsMethodMixin from './QuoteTotalsMethodMixin'
import QuoteNotificationMixin from './QuoteNotificationMixin'
import QuoteItemsMixin from './QuoteItemsMixin'
import { mapGetters, mapActions } from 'vuex'
import { roundAwayFromZero } from '@/components/utils/AccountingFunctions'
import Guid from '@/components/Guid'
import QuoteService from '../../QuoteService'
import { syncPartPaintLoading } from '../../helpers/PartsCheckSyncPartHelper'

const moduleName = 'quotes'

export default {
  mixins: [
    QuoteTotalsMethodMixin,
    QuoteItemsMixin,
    QuoteNotificationMixin
  ],
  computed: {
    partTotal() {
      if (this.mixinEntity) {
        return this.calculateItemCategoryTotal(this.mixinEntity.quotingMethod, this.mixinEntity.parts, ItemCategoryTypes.PART)
      }
    },
    ...mapGetters('quotes', {
      snapshotDiff: 'snapshotDiff',
      quoteInsurer: 'quoteInsurer',
      ntarLoadingItems: 'ntarLoadingItems',
      ntarOtherLoadingItems: 'ntarOtherLoadingItems',
      ntarLoadingValues: 'ntarLoadingValues',
      partsCheckSettingExists: 'partsCheckSettingExists',
      partsCheckSetting: 'partsCheckSetting'
    }),
    isNtar() {
      return (
        this.innerValue.labourType === LabourTimeTypes.NTAR ||
        this.innerValue.labourType === LabourTimeTypes.LTAR ||
        this.innerValue.labourType === LabourTimeTypes.eMTA
      )
    }
  },
  methods: {
    ...mapActions(moduleName, ['getExternalSetting']),
    updateValue(index, item) {
      // if (item && item.deleteOtherItem && item.itemQuantity > 0) {
      //   item.itemQuantity = item.itemQuantity * -1
      // }
      this.updateTotal()
    },
    updateMarkup(index, item) {

      console.log('here markup')

      if (!!this.innerValue.parts.length && !item.deleteOtherItem) {
        const itemToUpdate = this.innerValue.parts.find((i) => i.quoteItemId === item.quoteItemId)
        const markup = this.getMarkupPercent(item)
        itemToUpdate.markupValue = roundAwayFromZero(item.value + item.value * (markup / 100))
      }
      this.updateTotal()
    },
    async onPartConditionChange(item) {
      if (!!this.innerValue.parts.length) {
        const itemToUpdate = this.innerValue.parts.find((i) => i.quoteItemId === item.quoteItemId)
        const markup = this.getMarkupPercent(item)
        itemToUpdate.markupValue = roundAwayFromZero(item.value + item.value * (markup / 100))
        await this.addUpdatePartPaintLoading(item)
      }
      this.updateTotal()
      this.$eventHub.$emit(EventHubTypes.AutoSaveQuoteItems)
    },
    getMarkupPercent(item) {

      let markup = 0
      switch (item.mark) {
        case PartTypes.NEW.value:
          markup = this.innerValue.newMarkup
          break
        case PartTypes.USED.value:
          markup = this.innerValue.usedMarkup
          break
        case PartTypes.EXCH.value:
          markup = this.innerValue.exchangeMarkup
          break
        case PartTypes.RECR.value:
          markup = this.innerValue.recoreMarkup
          break
        case PartTypes.RECD.value:
          markup = this.innerValue.reconditionedMarkup
          break
        case PartTypes.ALTN.value:
          markup = this.innerValue.usedMarkup
          break
        case PartTypes.AFT.value:
          markup = this.innerValue.afterMarketMarkup
          break
        case PartTypes.CAFT.value:
          markup = this.innerValue.afterMarketMarkup
          break
        case PartTypes.AFTA.value:
          markup = this.innerValue.afterMarketMarkup
          break
      }

      console.log('markup', markup)

      return markup
    },
    async addUpdatePartPaintLoading(partItem) {
      if (!this.isNtar || !this.ntarLoadingItems || !this.quoteInsurer) {
        return
      }
      await syncPartPaintLoading({
        partItem,
        quoteEntity: this.innerValue,
        nextLineNumber: this.nextLineNumber,
        ntarLoadingItems: this.ntarLoadingItems,
        quoteInsurer: this.quoteInsurer,
        getDefaultPaintItem: this.getDefaultPaintItem,
        deletePaintLoadingItem: this.deletePaintLoadingItem,
        defaultPaintGroup: this.vehicle.paintGroup
      })
    },
    deletePaintLoadingItem(item) {
      let originalItemStatus = item.itemStatus
      // Always soft-delete; the debounced autosave PUTs synced items as deleted and
      // drops never-synced (isNew) deleted items from the payload itself. Splicing here
      // is unsafe: the local isNew flag can be stale after autosave has already
      // persisted the item, and a spliced item silently disappears from emits without
      // the server ever being told to delete it.
      item.deleted = true
      item.isDeleted = true
      item.itemStatus = QuoteItemStatusTypes.Deleted
      this.updateTotal()
      this.$toast.open({
        message: `Item <span class="is-italic">${item.itemDesc}</span> deleted`,
        type: 'is-danger',
        position: 'is-top',
        actionText: 'Undo',
        onAction: () => {
          item.deleted = false
          item.isDeleted = false
          item.itemStatus = originalItemStatus
          // The items autosave may have already dropped a never-synced (isNew) deleted
          // item from the live arrays while the toast was open — re-insert it so Undo
          // doesn't restore flags on a detached object and silently lose the item.
          if (!this.innerValue.labours.some((l) => l.quoteItemId === item.quoteItemId)) {
            this.innerValue.labours.push(item)
          }
          this.updateTotal()
        }
      })
    },
    async getDefaultPaintItem(itemNo) {
      const filter = {
        countryId: Guid.empty(),
        companyId: this.innerValue.companyId,
        query: itemNo,
        butterflyCode: '',
        scheduleId: this.vehicle.scheduleId || '',
        bodyId: this.vehicle.bodyId || '',
        bodySize: '',
        paintGroup: this.vehicle.paintGroup || '',
        variantId: 0,
        nvic: '',
        sortColumn: '',
        sortOrder: '',
        pageIndex: 1,
        pageSize: 1
      }
      const paintItem = await QuoteService.getAvailableLabourItems(filter, this.innerValue.labourType.toLowerCase())
      return paintItem
    }
  }
}
